module.exports = __webpack_public_path__ + "img/MinnaLogo.e055e41b.svg";